<template>
  <div id="app" :data-env="appEnv">
    <router-view />
  </div>
</template>

<script>
import { isWeixin, getCode } from "./functions";

export default {
  name: "App",
  computed: {
    appEnv() {
      return this.isWeixin() ? "wx" : "web";
    },
  },
  async mounted() {
    if (this.isWeixin()) {
      this.wxLogin();
    } else {
      try {
        await this.$store.dispatch("fetchInitData");
      // eslint-disable-next-line no-empty
      } catch (error) {}
    }
  },
  methods: {
    isWeixin,
    async wxLogin() {
      // 浏览器中调试，用以下代码
      // const openId = 'oFhzs1Kh8vmjB_fQ9voJCl7jAotM'; // 小太阳
      // await this.$store.dispatch('handleWeixinLogin', openId);
      // await this.$store.dispatch('fetchBanners');
      // await this.$store.dispatch('fetchGoods', {});
      // await this.$store.dispatch('fetchHeadingNews');
      // await this.$store.dispatch('fetchMarket', {});
      // eslint-disable-next-line no-debugger

      // 微信公众号线上环境调试
      const openId = localStorage.getItem("huozhewang_openId") || "";

      if (openId && openId !== "null") {
        const isSuccess = await this.$store.dispatch("handleWeixinLogin");
        if (isSuccess) {
          await this.$store.dispatch("fetchInitData");
        }
      } else {
        const code = getCode();

        if (code != null && code !== "") {
          await this.$store.dispatch("handelWxAuth");
          const isSuccess = await this.$store.dispatch("handleWeixinLogin");
          if (isSuccess) {
            await this.$store.dispatch("fetchInitData");
          }
        } else {
          // 没有监测到 code
          window.location.href =
            "http://www.huozhe666.com:8093/account/toOauth?redirect_uri=" +
            encodeURIComponent(window.location.href);
        }
      }
    },
  },
};
</script>

<style lang="less">
html,
body {
  height: 100%;
}
p {
  margin: 0;
  line-height: 26px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

.van-nav-bar .van-icon {
  color: #333 !important;
}

.van-nav-bar__arrow {
  font-size: 20px !important;
}

.has-header {
  padding-top: 46px;
}

.split {
  height: 10px;
  background-color: #f5f5f5;
}

.box {
  display: flex;
  p {
    margin: 0;
  }

  &-right {
    flex: 1;
  }

  &-left {
    padding-right: 15px;
  }

  .title {
    font-size: 14px;
    text-align: left;
    line-height: 20px;
  }

  .text {
    font-size: 12px;
    color: #646566;
    display: flex;
    justify-content: space-between;
  }
}
</style>
